import axios from 'axios';
import { Message } from 'ant-design-vue';
import { getCookie } from '@/utils/util';

let base = '';

if (window.location.host.indexOf(':7072') > 0) {
  //本地开发环境
  console.log('测试');
  base = 'https://ubtask.ver.cn:7072/api/task';
  // base = "http://192.168.10.182:7072/api/task";
} else if (
  window.location.host.indexOf('test') > -1 ||
  window.location.host.indexOf('192') > -1
) {
  base = 'https://ubtask.ver.cn:7072/api/task';
  // base = 'http://192.168.10.198:60020/api/task';
} else {
  //线上正式环境
  base = 'https://api.unrealbox.com/api/task';
  console.log('线上');
}

const service = axios.create({
  baseURL: base,
  timeout: 20000000,
});
axios.defaults.withCredentials = true;

service.interceptors.request.use(
  config => {
    // let token = sessionStorage.getItem("token") || "";
    let token = getCookie('ubToken');
    if (
      window.location.host.indexOf('test.unrealbox') > -1 ||
      window.location.host.indexOf('192') > -1
    ) {
      token = sessionStorage.getItem('token') || '';
    }
    if (token) {
      token = token.replace('"', '');
      config.headers['token'] = token;
    }
    return config;
  },
  error => {
    console.log('request -> error', error);
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  response => {
    // token 已过期，重定向到登录页面
    let { code, msg, message } = response.data;
    const msgData = msg || message;
    if (code == 1001) {
      // 业务异常 前端处理 不抛出
    } else if (code == 1002) {
      // 业务异常 需要弹窗错误提示
      Message.error(msgData);
    }
    if (code == 10001) {
      // 参数验证失败
      Message.error(msgData);
    } else if (code == 30001) {
      // 业务错误报告
      Message.error(msgData ? msgData : '服务器错误');
    } else if (code == 401) {
      // 登陆过期或未登陆
      if (
        response.request.responseURL.indexOf('information/queryInformation') ==
        -1
      ) {
        sessionStorage.removeItem('token');
        Message.error({
          content: msgData,
          duration: 1,
          key: 12,
          onClose() {
            window.location.href = '/#/login';
            window.location.reload();
          },
        });
      } else {
        sessionStorage.removeItem('token');
        window.location.href = '/#/login';
        window.location.reload();
      }
    } else if (code && code != 0 && code != 200) {
      Message.error(msgData);
    }
    return response.data;
  },
  () => {
    Message.destroy();
    Message.error('服务器异常');
  }
);

export default service;
